import React, { Component } from "react";
import { connect } from "react-redux";
import { Form, Dropdown, Grid } from "semantic-ui-react";
import axios from "axios";
import _ from "lodash";
import { expireSession } from "../../../actions/auth";
import settings, { getApiHost } from "../../../settings";
import InlineError from "../../messages/InlineError";
import {
  ERR_MSG_SESSION_EXPIRED,
  ERR_SELECT_ITEM_IN_LIST,
} from "../../../ErrorMessages";
import { addItemToCities } from "../../../actions/citiesList";

const defaultCityOption = {
  key: "-1",
  value: "-1",
  text: "Please select the state first",
};

class CityControl extends Component {
  constructor(props) {
    super(props);
    this.formCityRef = React.createRef();
    this.state = {
      options: [defaultCityOption],
      currentState: "-1",
    };
  }

  componentDidMount() {
    if (!this.props.stateCode || this.props.stateCode === "-1") {
      this.resetOptionsAndSetDefaultSelection(this.props);
    }
    if (
      this.props.stateCode &&
      this.props.stateCode !== "-1" &&
      this.props.stateCode !== this.state.currentState
    ) {
      this.loadData(this.props);
    }
  }

  componentWillReceiveProps(nextProps) {
    if (
      nextProps.firstErrorFieldName &&
      nextProps.firstErrorFieldName === nextProps.control.FieldName
    ) {
      if (nextProps.defaultData === "-1")
        setTimeout(() => {
          this.formCityRef.current.toggle();
        }, 100);
    }
    if (!nextProps.stateCode || nextProps.stateCode === "-1") {
      this.resetOptionsAndSetDefaultSelection(nextProps);
    }
    if (
      nextProps.stateCode &&
      nextProps.stateCode !== "-1" &&
      nextProps.stateCode !== this.state.currentState
    ) {
      this.loadData(nextProps);
    }
  }

  componentWillUnmount() {
    this.isCompMounted = false;
    if (this.state.cancelTokenSource !== undefined) {
      this.state.cancelTokenSource.cancel("City unmounting...");
    }
  }

  resetOptionsAndSetDefaultSelection = (props) => {
    this.setState({
      options: [defaultCityOption],
      currentState: props.stateCode ? props.stateCode : "-1",
    });
    if (
      !props.defaultData ||
      props.defaultData === "-1" ||
      props.stateCode === "-1"
    ) {
      const selOption = defaultCityOption;
      selOption.name = props.control.FieldName;
      this.handleCitySelect(this, selOption);
    }
  };

  isCompMounted = false;

  loadData = (props) => {
    this.isCompMounted = true;
    const appCitiesKey = props.stateCode;
    if (
      props.appCities &&
      Object.keys(props.appCities).includes(appCitiesKey)
    ) {
      const options = props.appCities[appCitiesKey];
      if (props.defaultData && props.defaultData !== "-1") {
        const option = _.find(
          options,
          (o) =>
            o.value ===
            (props.defaultData ? props.defaultData.toUpperCase() : "-1")
        );
        if (option) {
          const selOption = {
            name: props.control.FieldName,
            value: props.defaultData,
          };
          if (this.isCompMounted)
            this.setState({ options, currentState: props.stateCode });
          this.handleCitySelect(this, selOption);
        }
      } else {
        const selOption = {
          name: props.control.FieldName,
          value: defaultCityOption.value,
        };
        if (this.isCompMounted)
          this.setState({ options, currentState: props.stateCode });
        this.handleCitySelect(this, selOption);
      }
      return;
    }

    const cancelTokenSource = axios.CancelToken.source();
    axios
      .post(
        `${getApiHost(settings.env)}/cities.aspx`,
        {
          appName: settings.appName,
          StateCode: props.stateCode,
        },
        { async: false }
      )
      .then((res) => {
        if (_.get(res, "errors.error.errType") === "unauthorized") {
          localStorage.errorMessage = _.get(res, `errors.error.errMsg._`, "");
          props.expireSession();
          return;
        }
        const options = [
          {
            key: "-1",
            value: "-1",
            text: "All Available Cities",
          },
        ];
        _.map(res.data.Data, (city) => {
          options.push({
            key: city,
            value: city,
            text: city,
          });
        });
        let selOption = options[0];
        if (props.defaultData && props.defaultData !== "-1") {
          const option = _.find(
            options,
            (o) =>
              o.value.toLocaleLowerCase() ===
              props.defaultData.toLocaleLowerCase()
          );
          if (option) selOption = option;
        }
        selOption.name = props.control.FieldName;
        props.addItemToCities({ cityKey: appCitiesKey, cities: options });
        if (this.isCompMounted)
          this.setState({ options, cancelTokenSource: undefined });
        this.handleCitySelect(this, selOption);
      })
      .catch((err) => {
        console.log("Unable to load city - ", err);
        if (err.response && err.response.status === 401) {
          if (props && props.expireSession)
            props.expireSession(ERR_MSG_SESSION_EXPIRED);
          return;
        }
        if (this.isCompMounted) this.setState({ cancelTokenSource: undefined });
      });
    if (this.isCompMounted)
      this.setState({
        cancelTokenSource,
        currentState: props.stateCode,
      });
  };

  handleCitySelect = (e, data) => {
    if (this.props.notifyChangeToForm !== undefined)
      this.props.notifyChangeToForm(e, { name: data.name, value: data.value });
  };

  render() {
    const { control, isLeftSearch } = this.props;
    if (control === undefined) {
      return null;
    }
    const color = control.FieldRequired ? "red" : "black";
    return (
      <Grid.Row key={`drop_${control.FieldId}`}>
        {control.controlLabel !== "" &&
          (this.props.hideLabel === undefined || !this.props.hideLabel) ? (
          <Grid.Column width={isLeftSearch ? 6 : 6}>
            <Form.Field>
              <label
                htmlFor={control.FieldLabel}
                style={{ color }}
                className="padding-5"
              >
                {control.FieldLabel}
              </label>
            </Form.Field>
          </Grid.Column>
        ) : null}
        <Grid.Column width={isLeftSearch ? 10 : 10}>
          <Form.Field>
            <Dropdown
              fluid
              search
              selectOnBlur={false}
              selection
              key={`city_${control.FormId}_${control.FieldId}`}
              id={`city_${control.FormId}_${control.FieldId}`}
              options={this.state.options}
              name={control.FieldName}
              placeholder={control.controlPlaceholder}
              value={this.props.defaultData}
              label={control.FieldLabel}
              onChange={this.handleCitySelect}
              ref={this.formCityRef}
              size="small"
            />
          </Form.Field>
          {this.props.errors[control.FieldName] !== undefined &&
            this.props.errors[control.FieldName] !== "" && (
              <InlineError text={ERR_SELECT_ITEM_IN_LIST} />
            )}
        </Grid.Column>
      </Grid.Row>
    );
  }
}

function mapStateToProps(state) {
  return {
    appCities:
      state.appCitiesList && state.appCitiesList.appCities
        ? state.appCitiesList.appCities
        : undefined,
  };
}

export default connect(mapStateToProps, { expireSession, addItemToCities })(
  CityControl
);



// WEBPACK FOOTER //
// ./src/components/forms/controls/CityControl.js